import api from '../index'

const administration = {
  totalAdministration: async () => await api.get('administration/total')
}

export default administration
